import type { PiniaPluginContext } from 'pinia'
import { registerStoreForLogout } from '@/core/stores/storeRegistry'

/**
 * Pinia plugin that captures each store's initial state on creation
 * and restores it on logout — ensuring ALL state (including custom refs
 * like comments, statistics, subtitles) is properly cleared.
 *
 * Works with setup stores (which lack built-in $reset).
 */
export function storeResetPlugin({ store }: PiniaPluginContext) {
  // Skip auth and app stores - they manage their own lifecycle
  if (store.$id === 'auth' || store.$id === 'app') {
    return
  }

  // Capture the initial state snapshot (deep clone)
  const initialState = JSON.parse(JSON.stringify(store.$state))

  const clearFn = () => {
    store.$patch(JSON.parse(JSON.stringify(initialState)))
  }

  store.$clearOnLogout = clearFn
  registerStoreForLogout(store.$id, clearFn)
}

// Type augmentation for TypeScript
declare module 'pinia' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  export interface PiniaCustomProperties<Id, S, G, A> {
    $clearOnLogout: () => void
  }
}
